import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "./assets/style/style.scss";
import store from "./store";
import loader from './views/Loader.vue';
import VueSplit from 'vue-split-panel';
import VueLogger from 'vuejs-logger';
import ScrollLoader from 'vue-scroll-loader'
import { ApmVuePlugin } from '@elastic/apm-rum-vue'
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import Bowser from "bowser";

export const workoutEventBus = new Vue({name: 'workout-event-bus'});
const isProduction = process.env.VUE_APP_IS_PRODUCTION == 'true' ?? true;


import { i18n } from './i18n/index'

const options = {
  isEnabled: !isProduction,
  logLevel : 'debug',
  stringifyArguments : true,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};

// elastic application performance monitor
// https://www.elastic.co/guide/en/apm/agent/rum-js/master/configuration.html
const apmOptions = {
  router,
  config: {
    serviceName: process.env.VUE_APP_APM_AGENT_NAME,
    serverUrl: process.env.VUE_APP_APM_SERVER_URL,
    environment: process.env.VUE_APP_NODE_ENV,
    logLevel: process.env.VUE_APP_LOG_LEVEL,
  }
};
const popupOptions = {
  confirmButtonColor: '#73bc44',
  cancelButtonColor: '#646464',
}

const toastOptions = {
  position: POSITION.TOP_RIGHT
};

Vue.use(Toast, toastOptions);
Vue.use(ApmVuePlugin, apmOptions)

Vue.use(VueSplit);
Vue.use(VueLogger, options);
Vue.use(ScrollLoader)

Vue.config.productionTip = false;

import VueYoutube from 'vue-youtube'
import VueCarousel from 'vue-carousel';
import VueObserveVisibility from "vue-observe-visibility";

Vue.use(VueSweetalert2, popupOptions);
Vue.use(VueYoutube)
Vue.use(VueCarousel);
Vue.use(VueObserveVisibility);

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)
Vue.component('loader', loader);

const rememberedUser = sessionStorage.getItem('remember') || localStorage.getItem('remember');
// if (rememberedUser != "true") {
//   localStorage.clear();
// }

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_KEY },
  // appName: "Elitefit",
  // // pageTrackerScreenviewEnabled: true,
}, router);

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import './registerServiceWorker'

Vue.use(VueTelInput);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
